const projects = [
  {
    name: "Algorithm Visualizer",
    tech: "Java, JavaFX",
    date: "September 2024",
    desc: [
      "Overhauled sorting algorithms & tracked completion times using object-oriented programming principles.",
      "Eliminated concurrency issues that caused UI lag by multithreading JavaFX's application thread & sound playback.",
    ],
    images: ["/media/algovis.png", ""],
    github: "https://github.com/kphilippp/AlgorithmVisualizer",
  },
  {
    name: "Full-Stack Car Shop Website",
    tech: "React.js, Javascript, HTML/CSS, Express, AWS S3, MySQL",
    date: "August 2023",
    desc: [
      "Developed and integrated RESTful APIs to retrieve and display data from SQL and AWS S3 databases.",
      "Engineered a user-friendly interface using reusable React.js components, state management, and hooks.",
    ],
    images: [
      "/media/abimports.png",
      "/media/abimports2.png",
      "/media/abimports3.png",
      "/media/abimports4.png",
      "/media/abimports5.png",
      "/media/abimports6.png",
    ],
    github: "https://github.com/kphilippp/ABimportsWebsite",
  },
  {
    name: "Multi-threaded Linux Chatroom",
    tech: "Linux, C",
    date: "May 2024",
    desc: [
      "Constructed a client-server architecture in C using TCP sockets and multithreading.",
      "Provided communication support for up to 10 clients.",
    ],
    images: ["/media/chatroom.png"],
    github: "https://github.com/kphilippp/MultithreadedSocketServer",
  },
  {
    name: "SEOptimize AI SaaS App",
    tech: "Typescript, Python, OpenAI, AWS Lambda, AWS API Gateway, Javascript, FastAPI",
    date: "October 2024",
    desc: [
      "Constructed a client-server architecture in C using TCP sockets and multithreading.",
      "Provided communication support for up to 10 clients.",
    ],
    images: ["/media/SaasApp.png"],
    link: "https://ai-saas-app-swart.vercel.app/",
    github: "https://github.com/kphilippp/AI_Saas_App",
  },
  {
    name: "Realtime Stock Data Scraper",
    tech: "Apache Kafka, AWS EC2, AWS Glue, AWS Athena, AWS S3, Jupyter Notebook",
    date: "October 2024",
    desc: [""],
    images: [
      "/media/RealtimeStockScraper.png",
      "/media/RealtimeStockScraper2.png",
    ],
    github:
      "https://github.com/kphilippp/Realtime-Stock-Data-Scraper-AWS-Workshop",
  },
];

export default projects;
